import React from "react";
import { Skeleton } from "@material-ui/lab";
export const StorageMoveInfoSkeleton = ()=>{
  const columns = [
    "select_city",
    "pickup_address",
    "floor_no",
    "pickup_date",
    "elevator_available",
    "submit",
  ];
  const JSX = columns.map((value,index) => {
    return (
      <div className="m-2" key={"skeleton-nisis-" + index}>
        <Skeleton animation="wave" variant="rect" height={50} />
      </div>
    );
  });
  return (
    <>
      <div className="d-flex flex-column">{JSX}</div>
    </>
  );
}